snt-blog-info {
    // Mixins
    @mixin transition($prop: all, $time: 1s, $ease: linear) {
        -webkit-transition: $prop $time $ease;
        -moz-transition: $prop $time $ease;
        -o-transition: $prop $time $ease;
        -ms-transition: $prop $time $ease;
        transition: $prop $time $ease;
    }

    .spacings {
        @include layout();
    }

    #blog-info-bar {
        max-width: 1440px;
        border: 0;
        flex-direction: column;
    }



    // Styles
    .social-icons {
        display: none;
        text-align: center;

        div {
            display: inline-block;
            zoom: 1;
            *display: inline;
            vertical-align: middle;
            border-right: 0;
            padding: 0 20px;

            &:first-child {
                padding-left: 0px;
            }

            &:last-child {
                border-right: 0;
                padding-right: 0;
            }
            a {
                display: block;
                font-size: 1em;
                margin: 0 5px;
                text-decoration: none;
                i {
                    @include transition(all, 0.25s, ease-in);
                    @extend .icons-container;
                }
            }
        }
    }

    .schedule-info {
        display: flex;
        min-width: 100%;
        border: 0;
        margin-bottom: 25px;

        .icons-container {
            display: none;
        }

        p {
            font-size: 1em;
        }
    }

    .left-info {
        font-size: 0.875em;
    }

    .icons-container {
        color: $color-primary-grey;
        font-size: 1.5625em;
        display: inline-block;
        background-repeat: no-repeat;
        background-size: contain;
        padding-right: 5px;
    }

    .iconLinkedin:before,
    .iconFacebookPlain:before,
    .iconTwitter:before,
    .iconMail:before {
        color: $color-primary-grey;
    }

    a:hover {
        & .iconLinkedin:before,
        & .iconFacebookPlain:before,
        & .iconTwitter:before,
        & .iconMail:before {
            color: $color-primary-accent;
        }
    }

    .read-time-info {
        padding-left: 0;
        width: 100%;
        display: none;

        p {
            font-size: 1em;
        }
    }

    @media (min-width: map-get($grid-breakpoints, md)) {
        .left-info {
            flex: 0 1 auto;
            display: flex;
            align-items: center;
        }

        .schedule-info {
            display: flex;
            align-items: center;
            margin-bottom: 0;
            min-width: auto;
            .icons-container {
                display: block;
                padding-right: 20px;
                font-size: 2.142em;
            }
        }
        .read-time-info {
            display: none;
        }
        #blog-info-bar {
            border-top: 1px solid $color-primary-grey;
            border-bottom: 1px solid $color-primary-grey;
            flex-direction: row;
            height: 70px;
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
        .social-icons {
            flex: 3;
            justify-content: flex-end;
            display: flex;

            div {
                border-right: 1px solid $color-grey-06;
            }
        }
    }

    @media (min-width: map-get($grid-breakpoints, lg)) {
        .schedule-info {
            display: flex;
            align-items: center;
            min-width: 200px;
            text-align: left;
            border-right: 1px solid $color-grey-06;
            i.icon-calendar {
                display: block;
                padding-right: 20px;
            }
        }
        .read-time-info {
            padding-left: 30px;
            width: 50%;
            display: flex;
            align-items: center;

            .icons-container {
                font-size: 2.142em;
                padding-right: 20px;
            }
        }
        .social-icons {
            div {
                padding: 0 15px;
                a i {
                    width: 25px;
                    height: 25px;
                }
            }
        }
    }
}
